import { render } from "./resourceList.vue?vue&type=template&id=e9c5e520&scoped=true"
import script from "./resourceList.vue?vue&type=script&lang=js"
export * from "./resourceList.vue?vue&type=script&lang=js"

import "./resourceList.vue?vue&type=style&index=0&id=e9c5e520&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c5e520"]])

export default __exports__